import groq from 'groq';

export const SCROLL_VIDEO = groq`
  duration,
  "publicId": public_id,
  "frameCount": duration * 10
`;
